import request from '@/utils/request'
import qs from 'qs'

// 域账号登录
export const login1 = (data: { account: string, password: string }) =>
  request({
    url: '/app/ladpLogin',
    method: 'post',
    data: qs.stringify(data)
  })

// tutu账号登录
export const login2 = (data: { account: string, password: string }) =>
  request({
    url: '/app/tutuLogin',
    method: 'post',
    data: qs.stringify(data)
  })

// 登出
export const logout = (data: {token: string}) =>
  request({
    url: '/app/quit',
    method: 'post',
    data: qs.stringify(data)
  })

// 自动登录, token 续期
export const reLogin = (data: {token: string}) =>
  request({
    url: '/app/reLogin',
    method: 'post',
    data: qs.stringify(data)
  })
